import React from 'react';
export function Footer() {
  return <footer className="bg-[#1C1410] py-12 px-5 sm:px-6 border-t border-[#C9A96E]/10 text-center" data-id="element-126">
      <div className="container mx-auto max-w-3xl" data-id="element-127">
        <h3 className="text-[#C9A96E] font-serif font-bold text-xl md:text-2xl mb-2 tracking-widest" data-id="element-128">
          🌹 ACADEMIA HOLÍSTICA ARGENTINA™
        </h3>
        <p className="text-[#FAF3E8] text-sm md:text-base mb-8" data-id="element-129">
          El método de liberación genealógica Nº1 para mujeres argentinas.
          Porque lo que heredaste no tiene que definir lo que construís.
        </p>

        <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 text-[#C4856A] text-sm mb-10" data-id="element-130">
          <span className="flex items-center gap-2" data-id="element-131">
            📧 academiaholisticaargentina@gmail.com
          </span>
          <span className="flex items-center gap-2" data-id="element-132">
            📲 Instagram: @academiaholisticaargentina
          </span>
          <span className="flex items-center gap-2" data-id="element-133">
            📘 Facebook: Academia Holística Argentina
          </span>
        </div>

        <div className="text-[#D4A5A5] text-xs space-y-4" data-id="element-134">
          <p data-id="element-135">
            © Academia Holística Argentina™ 2026 — Todos los derechos
            reservados.
          </p>
          <p data-id="element-136">
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
          <p className="text-[#F5ECD7] font-serif italic text-lg mt-6" data-id="element-137">
            🌹 "El momento que siempre esperaste ya llegó."
          </p>
        </div>
      </div>
    </footer>;
}